import { KnownDeliveryContainerDtoType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { LockerDetailsActions } from './actions/locker-details.actions';
import { OpenLockerActionModal } from './actions/open-locker/open-locker-action.component';
import { useLockerDetails } from './hooks/use-locker-details.hook';
import { Snackbar } from '../../../ui/components/pure/snackbar/snackbar.component';
import { EnableDisableLockerActionModal } from './actions/enable-or-disable-locker/enable-disable-locker-action.component';
import { ReserveContainerActionModal } from './actions/reserve-container/reserve-container-action.component';
import { UnreserveContainerActionModal } from './actions/reserve-container/unreserve-container-action.component';

export function LockerDetailsActionsObserver({
  actions,
  state,
  projectID,
  containerID,
  containerType
}: {
  actions: ReturnType<typeof useLockerDetails>['actions'];
  containerID: string;
  containerType?: KnownDeliveryContainerDtoType;
  state: ReturnType<typeof useLockerDetails>['state'];
  projectID: string;
}) {
  switch (state.currentAction) {
    case LockerDetailsActions.OPEN_LOCKER:
      return (
        <OpenLockerActionModal
          lockerID={containerID}
          projectID={projectID}
          onSuccess={(statusHasChanged: boolean) =>
            actions.setAction(statusHasChanged ? LockerDetailsActions.OPEN_LOCKER_STATUS_CHANGE_SUCCESS : null)
          }
          onAbort={() => actions.setAction(null)}
        />
      );

    case LockerDetailsActions.OPEN_LOCKER_STATUS_CHANGE_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The status has been changed successfully.
        </Snackbar>
      );
    case LockerDetailsActions.ENABLE_DISABLE_LOCKER:
      return (
        <EnableDisableLockerActionModal
          lockerID={containerID}
          containerType={containerType}
          projectID={projectID}
          onSuccess={() => actions.setAction(LockerDetailsActions.ENABLE_DISABLE_LOCKER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );

    case LockerDetailsActions.ENABLE_DISABLE_LOCKER_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The status has been changed successfully.
        </Snackbar>
      );

    case LockerDetailsActions.RESERVE_CONTAINER:
      return (
        <ReserveContainerActionModal
          deliveryContainerID={containerID}
          projectID={projectID}
          onSuccess={() => actions.setAction(LockerDetailsActions.RESERVE_CONTAINER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );

    case LockerDetailsActions.RESERVE_CONTAINER_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The delivery container has been reserved.
        </Snackbar>
      );

    case LockerDetailsActions.UNRESERVE_CONTAINER:
      return (
        <UnreserveContainerActionModal
          deliveryContainerID={containerID}
          projectID={projectID}
          onSuccess={() => actions.setAction(LockerDetailsActions.UNRESERVE_CONTAINER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );

    case LockerDetailsActions.UNRESERVE_CONTAINER_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity="success">
          The reservation has been removed.
        </Snackbar>
      );

    default:
      return null;
  }
}
